//////////////////////////////////////////////////////////////////////////////
//
//  앱 공통 Config file
//
//  작성자: MyungHwan Kim
//  생성일: 2021-06-21
//  수정일:
//
//	설명: 전체 컨피그 설정 ex) baseurl, devmode 등등
//	Rest API 요청 중앙화 공용 모듈
//////////////////////////////////////////////////////////////////////////////

const devMode = "production" !== process.env.NODE_ENV;

const clubChatTopicLive = "CLUB_CHAT_SEQ_";
const clubChatTopicDev = "CLUB_CHAT_SEQ_DEV_";

// EC2 LIVE
const liveDomain = "https://api.live.mediinstep.co.kr";
//https://api.live.mediinstep.co.kr
// EC2 DEV
const testDomain = "http://test.mediinstep.co.kr";

// LOCAL
const devDomain = "http://172.30.1.81";

// const domain = devMode ? devDomain : testDomain;
const domain = devMode ? devDomain : testDomain;

const firebaseAccountTailor = devMode ? "@test.co.kr" : "@mediinstep.co.kr";
const clubChatTopic = devMode ? clubChatTopicDev : clubChatTopicLive;

// Dynamic port based on domain
const getPort = (currentDomain) => {
  if (currentDomain === testDomain) {
    return "5052"; // Test domain uses port 5052
  }
  return "5050"; // All other domains use port 5050
};

const port = getPort(domain);
// const port = "5050": // http
const socketPort = "12345";

export const AppConfig = {
  IOSStoreId: "1611270531",
  storeAppName: "MEDIINSTEP",
  isDevMode: devMode,
  firmName: "MEDIINSTEP",
  baseUrl: `${domain}:${port}/v0/`,
  socketUrl: `${domain}:${socketPort}`,
  imageUrl: `https://s3.ap-northeast-2.amazonaws.com/co.kr.usomnia.kora.s3`,
  secretKey: "*#FJAIDFJ@IJ@#JDKSF",
  storeType: "app",
  storeUrls: {
    android: "https://play.google.com/store/apps/details?id=com.mediinstep.app",
    ios: "", // TODO: iOS App Store URL 추후 제공 예정
  },
  externalService: {
    mapBox: {
      baseUrl: "https://api.mapbox.com/",
      accessToken:
        "sk.eyJ1IjoibWhwYzA5MDkiLCJhIjoiY2t1OThubzZxMDJiMzMxbXZkcTN3anp6diJ9.KpXjoKamW6qfhgxUmO8ayg",
    },
  },
  firebaseDomain: firebaseAccountTailor,
  keyboardAppearance: "dark",
  subsSharedKeyIOS: "5a9bcfbbf0824189a275fe6b94842fe6",
  defaultClubCount: 2,
  clubChatTopic: clubChatTopic,
  chat_collection: devMode ? "DEV_" : "",
  firmFooterStr: `@ ${new Date().getFullYear()}, MediStep Health Care. All rights reserved`,
  allPushTopic: devMode ? `dev.mediinstep.co.kr` : `mediinstep.co.kr`,
};

export const AuthConfig = {
  IOSStoreId: "1611270531",
  storeAppName: "MEDIINSTEP",
  snsPasswordSecrentKey: "@)SD@)ER#O@#KR@#EE2#$",
  mapboxAuth:
    "sk.eyJ1IjoibWhwYzA5MDkiLCJhIjoiY2t1OThubzZxMDJiMzMxbXZkcTN3anp6diJ9.KpXjoKamW6qfhgxUmO8ayg",
  loginType: {
    general: "A0101",
    facebook: "A0102",
    google: "A0104",
    kakao: "A0105",
    naver: "A0103",
    apple: "A0106",
  },
  naverClientId: "cJqWsQZya_n4nSaswN_I",
  naverClientSecret: "tbtxf42fUE",
  naverIosAppUrlScheme: "co.kr.usomnia.urlscheme.naverlogin",
  googleWebClientId: "883762176904-b5g96q2fsp00jlsao2mqucs2cscprplh.apps.googleusercontent.com",
};

export default { AppConfig, AuthConfig };
